import {
  Compass, Search, GitMerge, Users, Layers, Boxes,
  MousePointerClick, BarChart3, Lightbulb, PenTool,
} from "lucide-react";

const map = {
  Compass, Search, GitMerge, Users, Layers, Boxes,
  MousePointerClick, BarChart3, Lightbulb, PenTool,
};

export const getIcon = (name) => map[name] || PenTool;
